import { FC } from 'react';
import { UncontrolledTooltipProps } from 'reactstrap';

import Information from '@/library/components/general/Information';

import { useCompanySettingsDraft } from '../draft-context';
import { highlightSearchMatch } from '../highlight-search-match';

type InputLabelProps = {
  isCheckbox?: boolean;
  className?: string;
  title: string;
  apiKey?: string;
  information?: string;
  placement?: UncontrolledTooltipProps['placement'];
  informationTooltipPlacement?: UncontrolledTooltipProps['placement'];
};

const InputLabel: FC<InputLabelProps> = ({
  isCheckbox,
  className,
  title,
  apiKey,
  information,
  informationTooltipPlacement = 'top'
}) => {
  const { searchQuery } = useCompanySettingsDraft();

  return (
    <div className={`fs-10 lh-12 d-flex align-items-center ${className}`}>
      <span className={isCheckbox ? 'fs-12 fs-medium text-primary' : 'fw-bold text-primary'}>
        {highlightSearchMatch(title, searchQuery)}
      </span>
      {apiKey && (
        <span className="fw-medium text-lowercase text-violet">
          &nbsp;| {highlightSearchMatch(apiKey, searchQuery)}
        </span>
      )}
      {information && (
        <Information
          className="ms-2"
          tooltipClassname="max-width-none text-start cpx-6 cpy-12 lh-15"
          message={information}
          svgStyle={{ width: 12, height: 12 }}
          placement={informationTooltipPlacement}
        />
      )}
    </div>
  );
};

export default InputLabel;
